import { Navigate, RouteObject } from 'react-router-dom';
import { getOnboardingPath, Islands, OnboardingPages, Pages } from '../../common/src/pages';
import { localStorageGet, LocalStorageKey } from './data/client_local_storage.ts';
import { AdminInvite } from './pages/admin_invite';
import { HouseholdInvite } from './pages/household_invite';
import { OnboardingPage } from './pages/onboarding_page';
import { SubscriptionTrialPage } from './pages/subscription_trial_page.tsx';
import { getUrlForPage } from './util/path.ts';

// Where "/" and unknown paths land: the footer tab the visitor used last
export const MostRecentFooterTabRedirect = () => (
  <Navigate to={getUrlForPage(localStorageGet(LocalStorageKey.MostRecentFooterTab))} replace />
);

// The routes onboarding enters through or hands off to, kept apart from routes.tsx so that the
// onboarding flow tests (pages/onboarding/test) can mount them without the rest of the app
export const onboardingRoutes: RouteObject[] = [
  {
    path: Pages.AdminInvite,
    element: <AdminInvite />,
  },
  {
    path: Islands.Subscribe,
    element: <Navigate to={getOnboardingPath(OnboardingPages.SubscribeStart)} />,
  },
  {
    path: Islands.Download,
    element: <Navigate to={getOnboardingPath(OnboardingPages.Download)} />,
  },
  {
    path: Islands.Demo,
    element: <Navigate to={getOnboardingPath(OnboardingPages.Demo)} />,
  },
  {
    path: Pages.HouseholdInvite,
    element: <HouseholdInvite />,
  },
  {
    path: Pages.DeprecatedHouseholdInvite,
    element: <HouseholdInvite />,
  },
  {
    path: Pages.Onboarding,
    element: <OnboardingPage />,
  },
  {
    path: Pages.SubscriptionTrial,
    element: <SubscriptionTrialPage />,
  },
];
